import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import {
  checkRedeemAvailabilityAsync,
  flipmeConnectAsync,
  flipmeGetInfoAsync,
  flipmeNFTWithdrawAsync,
  flipMeRankRewardsAsync,
  redeemFlipmeCardAsync,
  redeemFlipmeCardInRankAsync
} from './FlipMeWallet.request';

import { ErrorToast } from '../../components';
import { RedeemFlipmeCardsStepsEnum } from '../Portfolio/RedeemFlipmeCards/types';

export const flipmeConnect = createAsyncThunk(
  'flipmeConnect',
  async (
    {
      emailCode,
      twoFACode,
      step,
      setStep
    }: {
      emailCode: string;
      twoFACode: string;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await flipmeConnectAsync({
        emailCode,
        twoFACode
      });

      setStep(step);

      dispatch(flipMeGetInfo());
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const flipMeGetInfo = createAsyncThunk('flipMeGetInfo', async () => {
  try {
    const { data } = await flipmeGetInfoAsync();

    return data;
  } catch (error: any) {
    ErrorToast(error.response.data.error);
  }
});

export const flipmeNFTWithdraw = createAsyncThunk(
  'flipmeNFTWithdraw',
  async (
    {
      userPackageId,
      step,
      setStep
    }: {
      userPackageId: number;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await flipmeNFTWithdrawAsync({
        userPackageId
      });

      setStep(step);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const redeemFlipmeCard = createAsyncThunk(
  'redeemFlipmeCard',
  async (
    {
      userPackageId,
      walletAddress,
      setRedeemFlipmeCardsStep
    }: {
      userPackageId: number | null | undefined;
      walletAddress: string;
      setRedeemFlipmeCardsStep: Dispatch<
        SetStateAction<RedeemFlipmeCardsStepsEnum>
      >;
    },
    { dispatch, getState }
  ) => {
    try {
      await redeemFlipmeCardAsync({
        userPackageId,
        walletAddress
      });

      setRedeemFlipmeCardsStep(RedeemFlipmeCardsStepsEnum.STEP3);

      dispatch(flipMeGetInfo());

      return userPackageId;
    } catch (error: any) {
      if (
        error.response.data.error ===
        'FlipMe card issuance failed: Identity verification is not approved'
      ) {
        setRedeemFlipmeCardsStep(RedeemFlipmeCardsStepsEnum.STEP4);
      } else {
        ErrorToast(error.response.data.error);
      }
    }
  }
);

// export const checkRedeemAvailability = createAsyncThunk(
//   'checkRedeemAvailability',
//   async () => {
//     try {
//       const { data } = await checkRedeemAvailabilityAsync();
//       return data;
//     } catch (error: any) {
//       ErrorToast(error.response.data.error);
//     }
//   }
// );

export const redeemFlipmeCardInRank = createAsyncThunk(
  'redeemFlipmeCardInRank',
  async (
    {
      setRedeemFlipmeCardsStep
    }: {
      setRedeemFlipmeCardsStep: Dispatch<
        SetStateAction<RedeemFlipmeCardsStepsEnum>
      >;
    },
    { dispatch, getState }
  ) => {
    try {
      await redeemFlipmeCardInRankAsync();
      setRedeemFlipmeCardsStep(RedeemFlipmeCardsStepsEnum.STEP3);
      dispatch(flipMeGetInfo());
    } catch (error: any) {
      setRedeemFlipmeCardsStep(RedeemFlipmeCardsStepsEnum.STEP4);
      ErrorToast(error.response.data.error);
    }
  }
);

export const flipMeRankRewards = createAsyncThunk(
  'flipMeRankRewards',
  async () => {
    try {
      const { data } = await flipMeRankRewardsAsync();

      return data;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
